import { Injectable } from '@angular/core';
import { MessageService } from '@progress/kendo-angular-l10n';

@Injectable({
  providedIn: 'root'
})
export class BIModulesService {
localId!:  string;
  constructor(private messages: MessageService) { }
  getDir(){
   return localStorage.getItem('isRightToLeft') === 'rtl'
  }
  setDir(){
    this.messages.notify(this.getDir());
  }
  getLocal(){
      if(localStorage.getItem('lang') === 'ar'){
       return 'ar-EG'
      }
      else {
        return 'en-US'
      }
  }
}
